import { ACTION } from './project_inspection_history_actions';
import {
  list_reducer,
  update_reducer,
} from '../reducers';

const initialState = {
  objects: {},
  orderedIds: [],
  loading: false,
  errorMessage: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ACTION.LIST}_PENDING`:
      return {
        ...state,
        loading: true,
        errorMessage: null,
      };
    case `${ACTION.LIST}_FULFILLED`:
      return {
        ...state,
        ...list_reducer(state, action),
        loading: false,
      };
    case `${ACTION.LIST}_REJECTED`:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload,
      };
    case `${ACTION.GET}_PENDING`:
      return {
        ...state,
        loading: true,
        errorMessage: null,
      };
    case `${ACTION.GET}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        loading: false,
        errorMessage: null,
      };
    case `${ACTION.GET}_REJECTED`:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/project_inspection/project_inspection_history_reducer.js